import * as NotificationsApiServices from '../services/api/requests/Notifications'

// gets number of unread notifs
export const doGetUnreadtNotificationCount = async ({
  accessToken,
  setNotificationCount = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => {
  try {
    const response = await NotificationsApiServices.getUnreadNotificationCount(
      accessToken,
    )
    const { values } = response.data || {}
    setNotificationCount(values)
    onSuccess(response)
  } catch (err) {
    onError(err)
  }
}
